import { createTheme } from "@mui/material/styles";

export const SchedulerTheme = ({ palette }) =>
    createTheme({
        palette,
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1200,
                smallDesktop: 1449,
                xl: 1536
            }
        },
        components: {
            MuiToolbar: {
                styleOverrides: {
                    root: {
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "0px",
                        padding: "0 !important",
                        borderBottom: "none !important"
                    }
                }
            },
            MuiBox: {
                styleOverrides: {
                    root: {
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: "0px"
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontSize: "14px",
                        fontWeight: "400",
                        color: palette.text.primary,
                        boxSizing: "border-box",
                        boxShadow: "none",
                        borderColor: palette.inputBorder.main,
                        borderRadius: "4px",
                        maxHeight: "36px",
                        "&:hover": {
                            borderColor: palette.inputBorder.main,
                            boxShadow: "none"
                        },
                        "&.TodayButton-button": {
                            "&:hover": {
                                background: "none !important"
                            }
                        }
                    },
                    text: {
                        fontSize: "14px",
                        fontWeight: "700",
                        padding: "0px",
                        minWidth: "unset",
                        color: palette.primary.main,
                        textTransform: "none",
                        "&:hover": {
                            backgroundColor: "transparent !important"
                        }
                    }
                }
            },
            MuiTouchRipple: {
                styleOverrides: {
                    root: {
                        "&:hover": {
                            background: "none !important"
                        }
                    }
                }
            },
            MuiSelect: {
                styleOverrides: {
                    root: {
                        fontSize: "14px",
                        fontWeight: "400",
                        boxSizing: "border-box",
                        boxShadow: "none",
                        borderColor: palette.inputBorder.main,
                        borderRadius: "4px",
                        maxHeight: "36px",
                        "&:hover": {
                            "&& fieldset": {
                                boxShadow: "none",
                                background: "inherit"
                            }
                        }
                    }
                }
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        padding: "10px 0 0 0",
                        fontSize: "14px",
                        color: palette.text.secondary
                    }
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        "&.Mui-focused": {
                            top: "12px"
                        }
                    },
                    shrink: {
                        top: "12px",
                        color: palette.text.secondary
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        display: "flex",
                        alignItems: "center",
                        alignContent: "center",
                        fontSize: "14px",
                        fontWeight: "400",
                        borderColor: palette.inputBorder.main,
                        borderRadius: "4px",
                        margin: "18px 0",
                        maxHeight: "36px",
                        padding: "14px 0px !important",
                        "&& fieldset": {
                            alignItems: "center",
                            alignContent: "center",
                            boxShadow: "none",
                            background: "inherit"
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: palette.inputBorder.main
                        },
                        "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                                borderColor: palette.primary.main
                            }
                    },
                    input: {
                        width: "100%",
                        padding: "0px 23px 0px 14px !important",
                        fontSize: "14px"
                    }
                }
            },
            MuiAutocomplete: {
                styleOverrides: {
                    inputFocused: {
                        padding: "12px 25px 12px 14px!important"
                    },
                    listbox: {
                        fontSize: "14px"
                    }
                }
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        minHeight: "36px",
                        axHeight: "36px",
                        fontSize: "14px"
                    }
                }
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        color: "grey",
                        "&:hover": {
                            "&& fieldset": {
                                boxShadow: "none"
                            }
                        }
                    }
                }
            },
            MuiTable: {
                styleOverrides: {
                    root: {
                        minWidth: "unset !important"
                    }
                }
            },
            MuiTypography: {
                styleOverrides: {
                    root: {
                        fontSize: "14px"
                    },
                    helperText: {
                        fontSize: "0.75rem",
                        fontWeight: "normal",
                        color: palette.helperText.main,
                        fontStyle: "italic",
                        fontFamily: ["Roboto", "sans-serif"].join(",")
                    },
                    errorText: {
                        margin: "3px 14px 0px 14px",
                        fontSize: "0.75rem",
                        fontWeight: "normal",
                        color: palette.error.main
                    }
                }
            }
        }
    });
